import React from 'react';
import { Plans } from '../components/Plans';
import { SeoContent } from '../components/SeoContent';

export const PlanosPage = () => {
  return (
    <div className="min-h-screen">
      <Plans />
      <SeoContent />
    </div>
  );
};